// removed by extract-text-webpack-plugin
module.exports = {"container":"container__35CkW","text":"text__3lRoJ","logo":"logo__kBkJ6","title":"title__3jUdv"};


//////////////////
// WEBPACK FOOTER
// ./components/trade/trade.css
// module id = o15H
// module chunks = 0